module.exports = __webpack_public_path__ + "img/meishuguanzhang.cf13fa05.png";